'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredProducts = getFilteredProducts;

var _actions = require('../helpers/actions');

function getFilteredProducts() {
  var articleNumberPartial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: 'GET_FILTERED_PRODUCTS',
    promise: function promise(_ref) {
      var api = _ref.api;
      return (0, _actions.handleErrors)(api('/quick_order/get_filtered_products/' + articleNumberPartial).get());
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/quickOrder.js
// module id = 2253
// module chunks = 0